module.exports = __webpack_public_path__ + "img/tips7.34238950.png";